import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./style/style.css";
import Footer from "./components/Footer/Footer";
import MobileBottomBar from "./components/Header/MobileBottomBar";
import ScrollingFooter from "./utils/ScrollingFooter";
import MainNav from "./components/Header/MainNav";
import LoggedInSidebar from "./components/Header/LoggedInSidebar";
import TopDemoPopup from "./components/Header/TopDemoPopup";
import FinancialButtonsmb from "./components/FinancialBtn/FinancialButtonsmb";
import Accountsidebar from "./components/Header/AccountSidebar";
import { getUserId, selectDomainID } from "./utils/helper/commonSelectors";
import ScrollToTop from "../ScrollToTop";
import {
  setUserOffline,
  setUserOnline,
  subscribeToJoinProfileRoom,
  subscribeToMatchData,
} from "../socketClient";
import { getBetMinMaxSetting, UserLockApplications } from "./api";
import { setbetSettings } from "./redux/slices/betSettingsSlice";
import { setUserLoackApplications } from "./redux/slices/userSlice";

// import ChangePasswordModal from "../ChangeUserPassword";
const AppLayout = () => {
  const location = useLocation();
  const usertype = useSelector((state) => state.account.accountType);
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const dispatch = useDispatch();
  const currentUserId = useSelector(getUserId());
  const [stakes, setStakes] = useState([
    { id: 1, buttonValue: "100" },
    { id: 2, buttonValue: "500" },
    { id: 3, buttonValue: "1000" },
    { id: 4, buttonValue: "5000" },
    { id: 5, buttonValue: "10000" },
    { id: 6, buttonValue: "50000" },
  ]);
  const domainID = useSelector(selectDomainID());
  // const [isPassWordModalOpen, setIsPassWordModalOpen] = useState(false);
  // const userData = useSelector((state) => state.account.profileData);
  // const isAuthenticated = useSelector((state) => state.user.isLoggedIn);
  // console.log(state,"state");

  // useEffect(() => {
  //   if (isAuthenticated && userData?.isFirstLogin) {
  //     console.log("Opening password modal - isAuthenticated:", isAuthenticated,
  //                "isFirstLogin:", userData?.isFirstLogin);
  //     setIsPassWordModalOpen(true);
  //   }
  // }, [isAuthenticated, userData]);

  // const handlePasswordChangeSuccess = async () => {
  //   setIsPassWordModalOpen(false);
  //   // Update the admin data in redux to reflect isFirstLogin as false
  //   dispatch(setUserData({
  //     ...userData,
  //     isFirstLogin: false
  //   }));
  //   toast.success("Password changed successfully");
  // };
  useEffect(() => {
    if (isLoggedIn&&usertype==="real") {
      const fetchInitialValues = async () => {
        const response = await getBetMinMaxSetting(domainID);
        if (!response?.success) {
          // toast.error("Network Error");
        } else {
          dispatch(setbetSettings(response?.data?.data));
        }
      };
      fetchInitialValues();
      const fetchUserLockApplications = async () => {
        const response = await UserLockApplications({domainId:domainID,userId:currentUserId});
        if (!response?.success) {
          // toast.error("Network Error");
        } else {
          dispatch(setUserLoackApplications(response?.data?.data));
        }
      };
      fetchUserLockApplications();
    }
  }, [isLoggedIn]);
  useEffect(() => {
    const savedStakes = localStorage.getItem("stakes");
    if (savedStakes) {
      setStakes(JSON.parse(savedStakes));
    } else {
      localStorage.setItem("stakes", JSON.stringify(stakes));
    }
  }, []);

  useEffect(() => {
    if (currentUserId) {
      // Initialize the socket connection when userId is available
      setUserOnline(currentUserId);

      return () => {
        setUserOffline(currentUserId);
      };
    }
  }, [currentUserId]);
  useEffect(() => {
    if (currentUserId) {
      // Initialize the socket connection when userId is available
      subscribeToJoinProfileRoom(currentUserId);
    }
  }, [currentUserId]);

  useEffect(() => {
    // Subscribe to all matches for each sport
    subscribeToMatchData({
      eventId: 4, // Cricket
      competitionId: null,
      matchId: null,
      marketId: null,
      sport: "cricket",
    });
    subscribeToMatchData({
      eventId: 1, // Soccer (fixed order to match your backend convention)
      competitionId: null,
      matchId: null,
      marketId: null,
      sport: "soccer",
    });
    subscribeToMatchData({
      eventId: 2, // Tennis
      competitionId: null,
      matchId: null,
      marketId: null,
      sport: "tennis",
    });
  }, []);

  const accountRoutes = [
    "/profile",
    "/account-statement",
    "/transactionsreport",
    "/profit-loss-report",
    "/bet-history",
    "/unsettled-bet",
    "/set-stake",
    "/rules",
    "/change-password",
    "/results",
    "/deposit",
    "/withdraw",
  ];

  const userNavigation = [
    "/in-play",
    "/election",
    "/kabaddi",
    "/wc-winner-2024",
    "/cricket",
    "/soccer",
    "/tennis",
    "/horse",
    "/greyhound",
    "/indian-poker",
    "/aviator",
    "/ae-sexy",
    "/evolution",
    "/ezugi",
    "/live-casino",
    "/vivo",
    "/betgames",
    "/casino-iii",
    "/casino-list",
    "/spribe",
    "/new-casino"
  ];

  const gridCheckPath = [...accountRoutes, "/demo", "/user", ...userNavigation];
  const pathname = location.pathname;

  // Exclude root path (`/`) from grid layout logic
  const gridLayout =
    pathname === "/"
      ? "" // No grid layout for root path
      : gridCheckPath.includes(pathname)
      ? "grid grid-cols-[0.2fr,1.2fr]"
      : "grid grid-cols-[0.2fr,0.69fr,auto]";

  return (
    <>
      <header className="sticky md:top-[26px] top-[0px] z-20 bg-white">
        <ScrollingFooter />
        <TopDemoPopup />
        <ScrollToTop />
        {/* {
          !isLoggedIn &&(
            <DownloadApp/>
          )
        } */}

        {/* {!isLoggedIn && <Topbar />} */}
        <MainNav
          FinancialButtonsmb={
            isLoggedIn && usertype === "real" ? <FinancialButtonsmb /> : null
          }
        />
      </header>

      <main className={`${gridLayout} max-lg:grid-cols-1`}>
        {pathname !== "/" && (
          <>
            {isLoggedIn ? (
              <section>
                {accountRoutes.includes(pathname) ? (
                  <Accountsidebar />
                ) : (
                  <LoggedInSidebar />
                )}
              </section>
            ) : (
              <section>
                {/* Sidebar for non-logged-in users */}
                <LoggedInSidebar />
              </section>
            )}
          </>
        )}
        <Outlet />
      </main>

      <footer>
        {pathname === "/" || pathname === "/user" || pathname === "/demo" ? (
          <Footer />
        ) : null}
        <MobileBottomBar />
      </footer>
      <></>
    </>
  );
};

export default AppLayout;
